"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringUtils = void 0;
class StringUtils {
    areSimilar(structureName, fileName) {
        if (typeof structureName !== 'string' || typeof fileName !== 'string') {
            return false;
        }
        const structureNameNoBlankSpaces = structureName
            .toLowerCase()
            .replace(/\s+/g, '');
        const fileNameNoBlankSpaces = fileName.toLowerCase().replace(/\s+/g, '');
        const structureNameNoBlankSpacesNoAccents = structureNameNoBlankSpaces
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
        const fileNameNoBlankSpacesNoAccents = fileNameNoBlankSpaces
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
        const similarity = this.calculateSimilarity(structureNameNoBlankSpacesNoAccents, fileNameNoBlankSpacesNoAccents);
        return this.isSimilar(similarity);
    }
    calculateSimilarity(str1, str2) {
        if (str1.length === 0 && str2.length === 0)
            return 100;
        if (str1.length === 0 || str2.length === 0)
            return 0;
        const matrix = [];
        for (let i = 0; i <= str1.length; i++) {
            matrix[i] = [i];
        }
        for (let j = 0; j <= str2.length; j++) {
            matrix[0][j] = j;
        }
        for (let i = 1; i <= str1.length; i++) {
            for (let j = 1; j <= str2.length; j++) {
                if (str1[i - 1] === str2[j - 1]) {
                    matrix[i][j] = matrix[i - 1][j - 1];
                }
                else {
                    matrix[i][j] = Math.min(matrix[i - 1][j] + 1, matrix[i][j - 1] + 1, matrix[i - 1][j - 1] + 1);
                }
            }
        }
        const distance = matrix[str1.length][str2.length];
        const maxLen = Math.max(str1.length, str2.length);
        return Math.round((1 - distance / maxLen) * 100);
    }
    isSimilar(similarity) {
        return similarity >= 90;
    }
}
exports.StringUtils = StringUtils;
//# sourceMappingURL=string-utils.js.map